import { BehaviorSubject, Observable } from 'rxjs';

export function convertToBehaviorSubject<T>(observable: Observable<T>, initValue: T): BehaviorSubject<T> {
  const subject = new BehaviorSubject(initValue);
  observable.subscribe(subject);
  return subject;
}
